import { useEffect, useState } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

const History = () => {

const [rules,setRules] = useState([]);
const [view,setView] = useState("week");
const [archiveMonth,setArchiveMonth] = useState(null);

useEffect(()=>{

const token = localStorage.getItem("token");
if(!token) return;

fetch(API+"/daily-rule/history",{
headers:{
Authorization:"Bearer "+token
}
})
.then(res=>res.json())
.then(data=>{
setRules(data || []);
});

},[]);

/* FILTER RULES */

function filterRules(){

const now = new Date();

if(view === "month"){

const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);

return rules.filter(rule=>{
if(!rule.date) return false;
return new Date(rule.date) >= firstDay;
});

}

if(view === "week"){

const today = new Date();
const day = today.getDay();
const diff = today.getDate() - day + (day === 0 ? -6 : 1);

const monday = new Date(today);
monday.setDate(diff);
monday.setHours(0,0,0,0);

return rules.filter(rule=>{
if(!rule.date) return false;
return new Date(rule.date) >= monday;
});

}

return rules;

}

/* GROUP BY WEEK */

function groupByWeek(data){

const weeks = {};

data.forEach(rule=>{

if(!rule.date) return;

const d = new Date(rule.date);
if(isNaN(d)) return;

const day = d.getDay();
const diff = d.getDate() - day + (day === 0 ? -6 : 1);

const monday = new Date(d);
monday.setDate(diff);
monday.setHours(0,0,0,0);

const sunday = new Date(monday);
sunday.setDate(monday.getDate() + 6);

const key = monday.getTime();

if(!weeks[key]){
weeks[key] = {
start:monday,
end:sunday,
items:[]
};
}

weeks[key].items.push(rule);

});

return Object.values(weeks).sort((a,b)=>b.start - a.start);

}

/* GROUP BY MONTH */

function groupByMonth(data){

const months = {};

data.forEach(rule=>{

if(!rule.date) return;

const d = new Date(rule.date);
if(isNaN(d)) return;

const year = d.getFullYear();
const month = d.getMonth();

const key = year + "-" + month;

if(!months[key]){
months[key] = {
year,
month,
items:[]
};
}

months[key].items.push(rule);

});

return Object.values(months).sort((a,b)=>{

const aDate = new Date(a.year,a.month);
const bDate = new Date(b.year,b.month);

return bDate - aDate;

});

}

/* RHYTHM STREAK */

function calculateStreak(data){

const dates = data
.filter(r=>r.date)
.map(r=>new Date(r.date).toISOString().split("T")[0])
.sort()
.reverse();

let current = 0;
let longest = 0;
let streak = 0;
let prev = null;

dates.forEach(d=>{

if(!prev){
streak=1;
}else{

const diff = (new Date(prev) - new Date(d)) / (1000*60*60*24);

if(diff===1){
streak++;
}else{
streak=1;
}

}

if(streak>longest) longest = streak;
prev=d;

});

current = streak;

return {current,longest};

}

/* PREPARE DATA */

let visibleRules = filterRules();

if(view === "archive" && archiveMonth){
visibleRules = archiveMonth.items;
}

const weeks = groupByWeek(visibleRules);
const archiveMonths = groupByMonth(rules);
const streak = calculateStreak(rules);

/* FORMAT WEEK TITLE */

function formatRange(start,end){

if(!start || !end) return "";

const s = new Date(start);
const e = new Date(end);

if(isNaN(s) || isNaN(e)) return "";

const options = { month:"long", day:"numeric" };

return "Week of "
+ s.toLocaleDateString("en-US",options)
+ " – "
+ e.toLocaleDateString("en-US",options);

}

/* WEEK PROGRESS */

function calculateProgress(week){

const days = new Set();

week.items.forEach(rule=>{
if(rule.date){
days.add(rule.date);
}
});

return days.size;

}

function progressBar(count){
return "█".repeat(count) + "░".repeat(7-count);
}

/* BUILD WEEK GRID */

function buildWeekGrid(week){

const days = {
1:false,
2:false,
3:false,
4:false,
5:false,
6:false,
0:false
};

week.items.forEach(rule=>{
if(!rule.date) return;

const d = new Date(rule.date);
const day = d.getDay();

days[day] = true;
});

const order = [1,2,3,4,5,6,0];

return order.map(d=>days[d] ? "■" : "□");

}

/* BUILD MONTH MAP */

function buildMonthMap(data){

const days = {};

data.forEach(rule=>{
if(!rule.date) return;

const d = new Date(rule.date);
const key = d.toISOString().split("T")[0];

days[key] = true;
});

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth();

const first = new Date(year,month,1);
const last = new Date(year,month+1,0);

const weeks = [];
let week = [];

for(let i=0;i<first.getDay();i++){
week.push(null);
}

for(let d=1; d<=last.getDate(); d++){

const date = new Date(year,month,d);
const key = date.toISOString().split("T")[0];

week.push(days[key] ? "■" : "□");

if(week.length===7){
weeks.push(week);
week=[];
}

}

if(week.length>0){
while(week.length<7) week.push(null);
weeks.push(week);
}

return weeks;

}

return(

<div className="history-space">

<h1>History</h1>

<div style={{
fontFamily:"Cormorant Garamond, serif",
fontSize:"0.95rem",
color:"#6a6665",
marginBottom:"10px"
}}>
Current Rhythm: {streak.current} days<br/>
Longest Rhythm: {streak.longest} days
</div>

<div className="history-subtitle">
Your Daily Rule
</div>

<div style={{
display:"flex",
gap:"12px",
marginBottom:"30px"
}}>

<button onClick={()=>{setView("week");setArchiveMonth(null);}}>
{view==="week" ? "[ Week ]" : "Week"} </button>

<button onClick={()=>{setView("month");setArchiveMonth(null);}}>
{view==="month" ? "[ Month ]" : "Month"} </button>

<button onClick={()=>{setView("archive");setArchiveMonth(null);}}>
{view==="archive" ? "[ Archive ]" : "Archive"} </button>

</div>

{/* ARCHIVE MONTH LIST */}

{view === "archive" && !archiveMonth && (

<div style={{marginBottom:"30px"}}>

{archiveMonths.map(month=>{

const name = new Date(month.year,month.month)
.toLocaleDateString("en-US",{month:"long",year:"numeric"});

return(

<div
key={month.year+"-"+month.month}
style={{
cursor:"pointer",
marginBottom:"10px",
fontFamily:"Cormorant Garamond, serif",
fontSize:"1.1rem"
}}
onClick={()=>setArchiveMonth(month)}
>

{name}

</div>

);

})}

</div>

)}

{/* BACK BUTTON */}

{view === "archive" && archiveMonth && (

<div style={{marginBottom:"20px"}}>

<button onClick={()=>setArchiveMonth(null)}>
← Back to months </button>

</div>

)}

{/* MONTH VIEW */}

{view === "month" && (

<div style={{marginBottom:"30px"}}>

<div style={{
fontFamily:"Cormorant Garamond, serif",
fontSize:"1rem",
marginBottom:"6px"
}}>
Monthly Faithfulness
</div>

<div className="month-header">
<span>M</span>
<span>T</span>
<span>W</span>
<span>T</span>
<span>F</span>
<span>S</span>
<span>S</span>
</div>

{buildMonthMap(rules).map((week,i)=>(

<div key={i} className="month-grid">

{week.map((d,j)=>(

<div key={j} className="month-cell">{d || ""}</div>
))}

</div>

))}

</div>

)}

{/* WEEKS */}

{weeks.map((week,index)=>{

const progress = calculateProgress(week);

return(

<div key={index}>

<div style={{
fontFamily:"Cormorant Garamond, serif",
fontSize:"1rem",
color:"#8a8685",
marginBottom:"4px"
}}>

{formatRange(week.start,week.end)}

</div>

<div style={{
fontSize:"0.9rem",
marginBottom:"10px",
color:"#6a6665"
}}>

Progress: {progressBar(progress)} {progress}/7 days

</div>

<div className="week-header">
<span>M</span>
<span>T</span>
<span>W</span>
<span>T</span>
<span>F</span>
<span>S</span>
<span>S</span>
</div>

<div className="week-squares">
{buildWeekGrid(week).map((d,i)=>(
<span key={i}>{d}</span>
))}
</div>

{week.items.map(rule=>(

<div key={rule.id} className="history-card">

<div className="history-date">
{new Date(rule.date).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}
</div>

<div className="history-section">
Orientation
</div>

<div>
{rule.orientation || "—"}
</div>

<div className="history-section">
Rhythm
</div>

<ul>
<li>{rule.rhythm?.morning ? "✓" : "○"} Morning</li>
<li>{rule.rhythm?.midday ? "✓" : "○"} Midday</li>
<li>{rule.rhythm?.afternoon ? "✓" : "○"} Afternoon</li>
<li>{rule.rhythm?.evening ? "✓" : "○"} Evening</li>
<li>{rule.rhythm?.night ? "✓" : "○"} Night</li>
</ul>

<div className="history-section">
Return
</div>

<div>
{rule.return_text || "—"}
</div>

<div className="history-section">
Examination
</div>

<ul>
<li>{rule.examen_checkboxes?.remembered_christ ? "✓" : "○"} remembered Christ</li>
<li>{rule.examen_checkboxes?.returned_after_failure ? "✓" : "○"} returned after failure</li>
<li>{rule.examen_checkboxes?.duties_kept ? "✓" : "○"} duties kept</li>
<li>{rule.examen_checkboxes?.charity_practiced ? "✓" : "○"} charity practiced</li>
<li>{rule.examen_checkboxes?.interior_peace_guarded ? "✓" : "○"} interior peace guarded</li>
</ul>

</div>

))}

</div>

);

})}

</div>

);

};

export default History;
